/**
 * Código del plan del usuario que se manda a comparsa (`/plan-returns?originDgsfp=`). FUENTE ÚNICA:
 * no repetir la expresión en las vistas.
 *
 * Es un código del registro de planes: DGSFP (`N` + 4 cifras) o, para un plan de previsión
 * asegurado dado de alta a mano, `PPA` + 3 o más cifras (comparsa#823). Mismo formato que
 * `REGISTRY_PLAN_CODE` en comparsa. Lo demás (vacío, «SIN-CODIGO») no se manda: comparsa
 * rechazaría la llamada entera y el plan de Arca tampoco se vería.
 */
const REGISTRY_PLAN_CODE = /^(N\d{4}|PPA\d{3,})$/;

export function originPlanCode(code: string | null | undefined): string | undefined {
	return code && REGISTRY_PLAN_CODE.test(code) ? code : undefined;
}
